import { render, staticRenderFns } from "./ClaimGadgetExcess.vue?vue&type=template&id=531911ea&"
import script from "./ClaimGadgetExcess.vue?vue&type=script&lang=js&"
export * from "./ClaimGadgetExcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports